// orion-web reports to Wix's org on the PUBLIC Sentry SaaS — https://wix-o.sentry.io — not the
// internal sentry.wixpress.com this pointed at during an earlier pass. This is the US-region ingest
// DSN for the orion-web project (org id o37417, project id 4511919392882688).
//
// A Sentry DSN is a public, browser-safe ingest key by design
// (https://docs.sentry.io/product/sentry-basics/dsn-explainer/), so — same reasoning as the ARTIFACT
// version below — it belongs in source control rather than a databag secret. Empty means Sentry.init
// is skipped everywhere (see instrumentation-client.ts / sentry.server.config.ts).
export const ORION_WEB_SENTRY_DSN =
  'https://80405d9a237266c9d942791a6b32bd4d@o37417.ingest.us.sentry.io/4511919392882688';

// The org + project slug the withSentryConfig webpack plugin references (see next.config.js).
// Event INGEST uses the numeric project id baked into the DSN above, so these slugs do not affect
// runtime reporting. Source-map UPLOAD is done by the Falcon `source-maps-upload` plugin, driven by
// the `source-maps-upload` target in package.json (its `sentryOrg`/`DSN`), NOT by these constants —
// so they matter only for a one-off local `SENTRY_AUTH_TOKEN=… next build`. Keep them in sync with
// SENTRY_ORG / SENTRY_PROJECT in next.config.js.
export const ORION_WEB_SENTRY_ORG = 'wix-o';
export const ORION_WEB_SENTRY_PROJECT = 'orion-web';
